import { render, staticRenderFns } from "./related_organization.vue?vue&type=template&id=d8df59e0&"
import script from "./related_organization.vue?vue&type=script&lang=js&"
export * from "./related_organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports